import {connect} from 'react-redux';
import {SliderSelect as Component} from './SliderSelect';
import {
  selectNewSequence,
  submitQuestionAnswer,
} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSelection: (params) => {
      dispatch(selectNewSequence(params));
    },
    submitAnswer: (id, type) => {
      dispatch(submitQuestionAnswer(id, type));
    },
  };
}
const SliderSelect = connect(mapStateToProps, mapDispatchToProps)(Component);

export {SliderSelect as SliderSelectWithRedux, Component as SliderSelect};
